import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.471.862a.667.667 0 10-.942.943l3.528 3.528H1.333a.667.667 0 100 1.334h7.724L5.53 10.195a.667.667 0 00.942.943l4.667-4.667a.667.667 0 000-.942L6.471.862z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol